import React, { FC, useEffect, useState } from "react";
import "./booking-detail.scss";
import CancelBookingModal from "../../../../shared/cancel-booking-modal/cancel-booking-modal";
import { useAppSelector } from "../../../../app/hooks";
import { useAppDispatch } from "../../../../app/hooks";
import {
  bookingActions,
  fetchBookingDetail,
  fetchBookingCancelStatus,
  fetchNetRateBookingStatus,
} from "../../bookingSlice";
import { useParams } from "react-router-dom";
import { DateTime } from "luxon";
import { capitalizeString, formatBookingUserPhone, getTotalPayout, getTotalPrice, mapTimeZone } from "../../../../utils/common";
import { useNavigate } from "react-router-dom";
import { capitalizeFullString } from "../../../../utils/common";
import { useTranslation } from "react-i18next";
import StatusBadge from "../../../../shared/components/StatusBadge";
import StatusModal from "../../../../shared/status-booking-modal/StatusModal";
import ProposeTime from "../../components/ProposeTime";
import SplitPaymentInfo, {
  getBookingSplitData,
  getSplitPaymentStatusKind,
} from "../../components/SplitPaymentInfo";

const getPaymentStatusDisplay = (booking: any, t: (key: string) => string) => {
  const splitKind = getSplitPaymentStatusKind(booking);
  if (splitKind === "paid") {
    return { label: t("Bookings.Paid"), className: "text-success" };
  }
  if (splitKind === "partiallyPaid") {
    return { label: "Partially Paid", className: "text-warning" };
  }
  if (splitKind === "pending") {
    return { label: "Pending Payment", className: "text-warning" };
  }
  const isPaid = booking?.paymentInfo?.status === "Success";
  return {
    label: isPaid ? t("Bookings.Paid") : t("Bookings.Failed"),
    className: isPaid ? "text-success" : "text-danger",
  };
};

const BookingDetail = () => {
  const [showCancelBookModal, setshowCancelBookModal] = useState(false);
  const [statusChangeModalData, setStatusChangeModalData]=useState<any>({show:false,action:null, bookedTesheetId:null})
  const handleCloseModal = (e: any) => {
    setshowCancelBookModal(false);
  };
  useEffect(() => {
    const elem: any = document.getElementById("mainBodyWrapper");
    elem.className = "mainBodyWrapper whiteBg";
    return () => {
      elem.className = "mainBodyWrapper";
    };
  });

  const dispatch = useAppDispatch();
  const {t}=useTranslation("")
  const navigate = useNavigate();
  const booking: any = useAppSelector(fetchBookingDetail);
  const bookingCancelStatus: string = useAppSelector(fetchBookingCancelStatus);
  const updateNetRateBookingStatus: string = useAppSelector(fetchNetRateBookingStatus);

  const { id }: any = useParams();
  const [selectedTeeTime, setSelectedTeeTime] = useState<any>(null);

  useEffect(()=>{
    if(updateNetRateBookingStatus){
      setStatusChangeModalData({show:false, action:null, bookedTesheetId:null});
      dispatch(bookingActions.bookingDetail(id))

    }
  },[updateNetRateBookingStatus])

  useEffect(() => {
    if (id) {
      dispatch(bookingActions.bookingDetail(id))
      // dispatch(bookingActions.bookingDetail(id));
    }
  }, []);

  const cancelBooking = (data: any) => {
    let apiData = {
      reason: data.reason,
      description: data.description,
    };
    dispatch(bookingActions.cancelBooking({ bookingId: id, data: apiData }));
  };

  const getUserName = (user: any) => {
    let fullName = "";
    if (user.firstname || user.lastname) {
      fullName = capitalizeFullString(`${user.firstname} ${user.lastname}`)
    } else if(user.name && typeof user.name==='string' ){
      fullName = capitalizeFullString(`${user.name}`)
    }
    else {
      if (user.role == "user") {
        fullName = t("Bookings.IntegolfUser")
      } else {
        fullName = t("Bookings.GuestUser")
      }
    }

    return fullName
  }

  const getClubAddress = (club: any) => {
    let name = [club.addressOne, club.addressTwo, club.city, club.countryName]
      .filter(Boolean)
      .join(", ");
    if (!name && typeof club.address === "string") name = club.address;
    if (!name && club.formattedName) name = club.formattedName;
    return capitalizeFullString(name)
  }

  const getTeesheetDateTimeISO = (teesheet: any) =>
    teesheet?.teesheetObj?.dateTimeISO ??
    teesheet?.teesheetIdDetail?.dateTimeISO ??
    teesheet?.dateTimeISO;

  const getTeeDate = (teesheet: any): string => {
    const iso = getTeesheetDateTimeISO(teesheet);
    const datePart = iso?.trim().slice(0, 10) ?? "";
    return /^\d{4}-\d{2}-\d{2}$/.test(datePart) ? datePart : "";
  };

  const openUpdateNetRateModal = (teesheet: any) => {
    setStatusChangeModalData({
      show: true,
      action: "updateConfirmation",
      bookedTesheetId: teesheet?._id,
      initialConfirmationNumber: teesheet?.confirmationNumber ?? "",
      initialStartTime: teesheet?.startTime ?? "",
      initialTeeDate: getTeeDate(teesheet),
    });
  };

  const getTeesheetHoles = (teesheet: any) =>
    teesheet?.teesheetObj?.holes ?? teesheet?.teesheetIdDetail?.holes ?? teesheet?.course?.holes;

  const getTotalTeesheetPrice = (teesheets: any) =>{
    let totalPrice = teesheets.reduce((sum:any, currentItem:any) => {
      let price = Number((currentItem.price * currentItem.players).toFixed(2));
      return sum + price;
    }, 0);

    return totalPrice.toFixed(2)
  }

  return (
    <>
    {(booking['_id'])? 
    <div className="bookingDetailWrapper">
    <section className="commonHeader">
      <div className="container">
        <div className="row gutters-10 align-items-center">
          <div className="col-auto">
            <a
              className="button button-s3 button-border button-circle button-sm"
              onClick={() => navigate(-1)}
            >
              <em className="fas fa-arrow-left"></em>
            </a>
          </div>
          <div className="col-12 col-lg">
            <ul className="navBreadCrumb">
              {/* <li>
                <a href="#!;">Upcomming</a>
              </li> */}
              <li>
                <span>{t("Bookings.BookingDetails")}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <div className="bookingDetailWrap py-4">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-7">
            {booking?.user && (
              <div className="bookingDetailCustomer">
                <h1 className="bookingDetailCustomer__name">{getUserName(booking?.user)}</h1>
                <p className="bookingDetailCustomer__email">
                  {formatBookingUserPhone(booking?.user) && (
                    <span className="bookingDetailCustomer__phone d-block mb-1">
                      {formatBookingUserPhone(booking?.user)}
                    </span>
                  )}
                  {booking?.user?.email ? booking?.user?.email : "-"}
                </p>
              </div>
            )}

            <div className="bookingDetailCards">
            {
              booking?.teesheets?.map((teesheet:any, teeIndex: number) => (
               <article key={teesheet?._id ?? teeIndex} className="bookingDetailCard">
                <div className="bookingDetailCard__header">
                  <div className="bookingDetailCard__headerMain">
                    <h2 className="bookingDetailCard__title">
                      {capitalizeFullString(teesheet?.club?.name)}
                    </h2>
                    <p className="bookingDetailCard__location">
                      <em className="icon-location"></em>
                      {teesheet?.club && getClubAddress(teesheet.club)}
                    </p>
                    <div className="bookingDetailCard__badges">
                      {teesheet?.status?.value == "courseConfirmationPending" && (
                        <StatusBadge bg={"warning"} text={t("Bookings.CourseConfirmationPending")}/>
                      )}
                      {teesheet?.status?.value == "userConfirmationPending" && (
                        <StatusBadge bg={"warning"} text={"User Confirmation Pending"}/>
                      )}
                      {(teesheet?.status?.value == "success" || teesheet?.status?.value == "accepted") && (
                        <StatusBadge bg={"success"} text={t("Accepted")} textColor="white"/>
                      )}
                      {teesheet?.status?.value == "rejected" && (
                        <StatusBadge bg={"danger"} text={"Rejected"} textColor="white"/>
                      )}
                      {teesheet?.status?.value == "refunded" && (
                        <StatusBadge bg={"danger"} text={"Refunded"} textColor="white"/>
                      )}
                      {teesheet?.isNetRate && (
                        <StatusBadge bg={"primary"} text={t("NetRatePage.statusNetRate")} textColor="white"/>
                      )}
                    </div>
                  </div>
                  {teesheet?.course?._id && teesheet?.club?._id && (
                    <a
                      href={void 0}
                      onClick={() => {
                        navigate(`/course?courseId=${teesheet?.course?._id}&clubId=${teesheet?.club?._id}`);
                      }}
                      className="bookingDetailCard__viewCourse"
                    >
                      {t("Bookings.ViewCourse")}
                    </a>
                  )}
                </div>

                <div className="bookingDetailCard__details">
                  <div className="bookingDetailCard__detailItem _item">
                    <label>{t("Bookings.TeeTime")}</label>
                    <h5 className={teesheet?.isNetRate && (teesheet?.status?.value === "success" || teesheet?.status?.value === "accepted") ? "bookingDetailCard__confirmation" : undefined}>
                      <span>
                        {teesheet?.isNetRate
                          ? `${DateTime.fromISO(getTeesheetDateTimeISO(teesheet), {zone:mapTimeZone(teesheet?.club)}).toFormat("dd MMM yyyy")}, ${teesheet?.startTime ?? ""}`
                          : DateTime.fromISO(getTeesheetDateTimeISO(teesheet), {zone:mapTimeZone(teesheet?.club)}).toFormat("h:mm a, EEE dd MMM yyyy")}
                      </span>
                      {teesheet?.isNetRate && (teesheet?.status?.value === "success" || teesheet?.status?.value === "accepted") && (
                        <button
                          type="button"
                          className="bookingDetailCard__editBtn"
                          onClick={() => openUpdateNetRateModal(teesheet)}
                          title="Update tee time and confirmation number"
                        >
                          <i className="fas fa-pen"></i>
                        </button>
                      )}
                    </h5>
                  </div>
                  {teesheet?.isNetRate && (teesheet?.status?.value === "success" || teesheet?.status?.value === "accepted") && (
                    <div className="bookingDetailCard__detailItem _item">
                      <label>Confirmation number</label>
                      <h5 className="bookingDetailCard__confirmation">
                        <span>{teesheet?.confirmationNumber ? teesheet.confirmationNumber : "-"}</span>
                        <button
                          type="button"
                          className="bookingDetailCard__editBtn"
                          onClick={() => openUpdateNetRateModal(teesheet)}
                          title="Update tee time and confirmation number"
                        >
                          <i className="fas fa-pen"></i>
                        </button>
                      </h5>
                    </div>
                  )}
                  {teesheet?.status?.value === "userConfirmationPending" && (
                    <div className="bookingDetailCard__detailItem _item">
                      <label>Proposed Tee time</label>
                      <h5>
                        {teesheet?.merchantNetRateProposal?.startTime}{" "}
                        <i className="fa-solid fa-clock"></i>
                      </h5>
                    </div>
                  )}
                  <div className="bookingDetailCard__detailItem _item">
                    <label>{t("Bookings.NumberOfGolfers")}</label>
                    <h5>{teesheet?.players} {t("Bookings.players")}</h5>
                  </div>
                  <div className="bookingDetailCard__detailItem _item">
                    <label>{t("Bookings.NumberOfHoles")}</label>
                    <h5>{getTeesheetHoles(teesheet)}</h5>
                  </div>
                </div>

                {teesheet.isNetRate && teesheet.status.value === "courseConfirmationPending" && (
                  <div className="bookingDetailCard__actions">
                    <button
                      type="button"
                      className="bookingDetailCard__btn bookingDetailCard__btn--accept"
                      onClick={() => setStatusChangeModalData({
                        show: true,
                        action: "accept",
                        bookedTesheetId: teesheet?._id,
                        initialStartTime: teesheet?.startTime ?? "",
                        initialTeeDate: getTeeDate(teesheet),
                        isFromItineraryCart: Boolean(teesheet?.isFromItineraryCart),
                        parentBookingId: teesheet?.isFromItineraryCart ? booking?._id : undefined,
                        cartTeesheetId: teesheet?.cartTeesheetId || teesheet?._id,
                      })}
                    >
                      <i className="fas fa-check" aria-hidden="true"></i>
                      {t("DiscountsRequestsPage.acceptButton")}
                    </button>
                    <button
                      type="button"
                      className="bookingDetailCard__btn bookingDetailCard__btn--reject"
                      onClick={() => setStatusChangeModalData({show: true, action: "reject", bookedTesheetId: teesheet?._id})}
                    >
                      <i className="fas fa-times" aria-hidden="true"></i>
                      {t("DiscountsRequestsPage.RejectButton")}
                    </button>
                  </div>
                )}
              </article>
              ))
            }
            </div>
            {booking?.orders && booking.orders.products?.length > 0 &&
              <div className="row gutters-5 mt-3">
                {booking?.orders && booking.orders.products?.length > 0 &&
                  booking?.orders?.products.map((order: any, index: number) => (
                    <div className="col-auto">
                      {order?.quantity && <label className="badge mb-2">{order?.title}: {order?.quantity}</label>}
                    </div>))}
              </div>
            }
           

            {/* hotel section for package booking  */}
            { booking?.bookingType === 4 && <>

            <div className="row">
              <div className="col">
                <h2 className="mb-3">
                  {capitalizeFullString(booking?.bookedaccomodations?.name ?? '')}
                </h2>
                <p className="color-700">
                  <em className="icon-location"></em>
                  {booking?.bookedaccomodations && booking.bookedaccomodations?.formattedName}
                </p>
              </div>
              
            </div>
            <div className="row gutters-7 mt-2">
              <div className="col-12 col-sm _item">
                <label className="color-700 mb-2">{t("Bookings.Rooms")}</label>
                {/* {booking.teesheets && booking.teesheets.length == 1 && <h5 className="color-800">
                  {booking?.teesheets && booking.teesheets.length > 0 && booking?.teesheets[0].teesheetId
                    ? DateTime.fromMillis(
                      booking?.teesheets[0]?.dateTime
                    ).toFormat("h:mm a, EEE dd MMM yyyy")
                    : "n/a"}
                </h5>} */}

                {booking.bookedaccomodations && booking.bookedaccomodations?.rooms?.length > 0 &&
                  booking.bookedaccomodations.rooms.map((room: any, index: number) => (
                    <h5 className="color-800">
                      {room?.roomType ?? ''}
                    </h5>))}
                {/* {booking.teesheets && booking.teesheets?.length > 1 && <h5 className="color-800">
                  {booking?.teesheets[0]?.teesheetId
                    ? DateTime.fromMillis(
                      booking?.teesheets[booking.teesheets.length - 1]?.dateTime
                    ).toFormat("dd MMM yyyy")
                    : "n/a"}
                  {", "}
                  {booking?.teesheets[0]?.teesheetId
                    ? DateTime.fromMillis(
                      booking?.teesheets[0]?.dateTime
                    ).toFormat("h:mm a")
                    : "n/a"} {"- "}
                  {booking?.teesheets[0]?.teesheetId
                    ? DateTime.fromMillis(
                      booking?.teesheets[booking.teesheets.length - 1]?.dateTime
                    ).toFormat("h:mm a")
                    : "n/a"}
                </h5>
                } */}
              </div>
              {booking?.golfPackage?.itineraryStartDate && <div className="col-12 col-sm _item">
                <label className="color-700 mb-2">{t("Bookings.CheckIn")}</label>
                <h5 className="color-800">
                  {DateTime.fromISO(booking?.golfPackage?.itineraryStartDate, {zone: booking?.teesheets?.[0]?.club?.timezone }).toFormat("hh:mm a, LLL dd, yyyy")}
                  {/* , {booking?.holes} Holes */}
                </h5>
              </div>}
              {booking?.golfPackage?.itineraryEndDate && <div className="col-12 col-sm _item">
                <label className="color-700 mb-2">{t("Bookings.CheckOut")}</label>
                <h5 className="color-800">
                {DateTime.fromISO(booking?.golfPackage?.itineraryEndDate, {zone: booking?.teesheets?.[0]?.club?.timezone }).toFormat("hh:mm a, LLL dd, yyyy")} 
                  {/* , {booking?.holes} Holes */}
                </h5>
              </div>}
            </div>

            <hr />
            </>}
           
            {/* hotel section ends */}




            <div className="row gutters-10 actionBlock">
              {(booking?.status?.value == "cancelled") && (
                <label className="_label active fontsize-14 fw700 my-2">
                  {t("Bookings.BookingCancelled")}
                </label>
              )}
              
              
              {booking?.status?.value == "failed" && !getBookingSplitData(booking) && (
                <label className="_label active fontsize-14 fw700 my-2">
                  {t("Bookings.PaymentFailed")}
                </label>
              )}

              
            </div>


          </div>
          <div className="col-12 col-lg-5">
            <div className="bookingDetailSidebar">
            <div className="bookingDetailMeta">
              <div className="bookingDetailMeta__item">
                <span className="bookingDetailMeta__label">{t("Bookings.BookedOn")}</span>
                <span className="bookingDetailMeta__value">
                  {booking?.createdAt
                    ? DateTime.fromMillis(booking?.createdAt, {zone:mapTimeZone(booking?.teesheets?.[0]?.club)}).toFormat(
                      "ccc, LLL dd, yyyy h:mm a"
                    )
                    : "n/a"}
                </span>
              </div>
              <div className="bookingDetailMeta__item">
                <span className="bookingDetailMeta__label">{t("Bookings.BookingCode")}</span>
                <span className="bookingDetailMeta__value bookingDetailMeta__value--code">{booking?.bookingId}</span>
              </div>
            </div>

            <div className="_paySection mb-2">
              <h3 className="_paySection-title mb-3">{t("Bookings.Charges")}</h3>

             { booking?.bookingType == 4 ? 
                <div className="row align-items-center gutters-10 _priceRow">
                <div className="col">
                  <label className="fw500 mb-0">
                  {t("Bookings.PackageTotal")}
                    {/* {booking?.noOfGuest ? booking?.noOfGuest : booking?.teesheets[0]?.players} Golfers x ${booking?.price} */}
                  </label>
                </div>
                <div className="col-auto">
                  <h6 className="mb-0 fw700">
                    $ {Number(booking?.golfPackage?.price ?? 0).toFixed(2)}
                    {/* $ {(booking?.price * booking?.players).toFixed(2)} */}
                  </h6>
                </div>
              </div>
             
             : <div className="row align-items-center gutters-10 _priceRow">
                <div className="col">
                  <label className="fw500 mb-0">
                  {t("Bookings.GolfTotal")}
                    {/* {booking?.noOfGuest ? booking?.noOfGuest : booking?.teesheets[0]?.players} Golfers x ${booking?.price} */}
                  </label>
                </div>
                <div className="col-auto">
                  <h6 className="mb-0 fw700">
                    $ {getTotalTeesheetPrice(booking?.teesheets)}
                    {/* $ {(booking?.price * booking?.players).toFixed(2)} */}
                  </h6>
                </div>
              </div> }

              {booking?.orders && booking.orders.products?.length > 0 &&
                booking?.orders?.products?.map((order: any, index: number) => (
                  <>
                    {order?.price &&
                      <div className="row align-items-center gutters-5 _priceRow">
                        <div className="col">
                          <div className="row gutters-5 justify-content-between">
                            <div className="col">
                              <label className="fw500 mb-0"> {order?.title}</label>
                            </div>
                            <div className="col-auto">
                              <label className="fw500 mb-0">$ {order?.price} X {order?.quantity}</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-auto">
                          <h6 className="mb-0 fw700">$ {((order?.price) * (order?.quantity)).toFixed(2)}</h6>
                        </div>
                      </div>
                    }
                  </>

                ))}



              {booking?.teesheets[0]?.discountPercent > 0 && (
                <div className="row align-items-center gutters-10 _priceRow">
                  <div className="col">
                    <label className="fw500 mb-0">
                    {t("Bookings.Discount")} ({booking?.teesheets[0]?.discountPercent}%)
                    </label>
                  </div>
                  <div className="col-auto">
                    <h6 className="mb-0 fw700">
                      -${" "}
                      {booking?.teesheets[0]?.discountAmount
                        ? (booking?.teesheets[0]?.discountAmount).toFixed(2)
                        : ""}
                    </h6>
                  </div>
                </div>
              )}

              {/* <div className="row align-items-center gutters-10 _priceRow">
                <div className="col">
                  <label className="fw500 mb-0">Booking Fee (5%)</label>
                </div>
                <div className="col-auto">
                  <h6 className="mb-0 fw700">
                    ${" "}
                    {booking?.bookingFees
                      ? booking?.bookingFees.toFixed(2)
                      : ""}
                  </h6>
                </div>
              </div> */}

              {/* {<div className="row align-items-center gutters-10 _priceRow">
                <div className="col">
                  <label className="fw500 mb-0">Tax</label>
                </div>
                <div className="col-auto">
                  <h6 className="mb-0 fw700">$ {booking?.taxAmt}</h6>
                </div>
              </div> } */}

              {/* {booking?.credits > 0 && <div className="row align-items-center gutters-10 _priceRow">
                <div className="col">
                  <label className="fw500 mb-0">Credits ( {booking?.credits ?? 0} x ${(Number(booking?.creditAmt ?? 0) / Number(booking?.credits ?? 0)).toFixed(2)} )</label>
                </div>
                <div className="col-auto">
                  <h6 className="mb-0 fw700">-$ {booking?.creditAmt?.toFixed(2)}</h6>
                </div>
              </div> } */}
              {/* {booking?.isLuckyBooking && <div className="row align-items-center gutters-10 _priceRow">
                <div className="col">
                  <label className="fw500 mb-0">Lucky booking Promo</label>
                </div>
                <div className="col-auto">
                  <h6 className="mb-0 fw700">-$  {(booking?.totalPrice).toFixed(2)}</h6>
                </div>
              </div> } */}
              

              <div className="row align-items-center gutters-10 _priceRow">
                <div className="col">
                  <h5 className="fw700 mb-0">{t("Bookings.Total")}</h5>
                </div>
                <div className="col-auto">
                  <h5 className="mb-0 fw700">
                    ${" "}
                    { getTotalPrice(booking) ?? '0.00'}
                  </h5>
                </div>
              </div>
            </div>
            { <div className="_paySection mb-2">
              <h3 className="_paySection-title mb-3">{t("Bookings.Payment")}</h3>

              {(() => {
                const paymentStatus = getPaymentStatusDisplay(booking, t);
                return (
                  <div className="row align-items-center gutters-10 _priceRow">
                    <div className="col">
                      <h5 className="fw700 mb-0">{t("Bookings.Status")}</h5>
                    </div>
                    <div className="col-auto">
                      <h5 className={`mb-0 fw700 ${paymentStatus.className}`}>
                        {paymentStatus.label}
                      </h5>
                    </div>
                  </div>
                );
              })()}

              <SplitPaymentInfo booking={booking} />
            </div>}

            {booking?.paymentInfo?.status === "Success" && booking?.status?.value === "completed" && <div className="_paySection mb-2">
              <h3 className="_paySection-title mb-3">{t("Bookings.Payout")}</h3>

              <div className="row align-items-center gutters-10 _priceRow">
                <div className="col">
                  <h5 className="fw700 mb-0">{t("Bookings.Total")}</h5>
                </div>
                <div className="col-auto">
                  <h5 className="mb-0 fw700">
                   $ {getTotalPayout(booking)}
                  </h5>
                </div>
              </div>
            </div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>:<></>}

  <StatusModal
    message={
      statusChangeModalData.action === "updateConfirmation"
        ? "Update tee time and confirmation number?"
        : `Are you sure you want to ${statusChangeModalData.action}?`
    }
    buttonText={
      statusChangeModalData.action === "updateConfirmation"
        ? "Save changes"
        : `Yes, ${statusChangeModalData.action}`
    }
    onCloseClick={()=>{setStatusChangeModalData({show:false, action:null, bookedTesheetId:null})}}
    showModal={statusChangeModalData.show}
    action={
      statusChangeModalData.action === "accept"
        ? "accept"
        : statusChangeModalData.action === "reject"
          ? "reject"
          : statusChangeModalData.action === "updateConfirmation"
            ? "updateConfirmation"
            : undefined
    }
    initialConfirmationNumber={statusChangeModalData?.initialConfirmationNumber}
    initialStartTime={statusChangeModalData?.initialStartTime}
    initialTeeDate={statusChangeModalData?.initialTeeDate}
    OnSubmit={(payload)=>{
      dispatch(bookingActions.updateNetRateBooking({
        bookingId:statusChangeModalData?.bookedTesheetId,
        data:{
          status:
            statusChangeModalData.action === "accept" || statusChangeModalData.action === "updateConfirmation"
              ? "success"
              : "rejected",
          ...(statusChangeModalData?.isFromItineraryCart && statusChangeModalData?.parentBookingId
            ? {
                parentBookingId: statusChangeModalData.parentBookingId,
                cartTeesheetId: statusChangeModalData.cartTeesheetId,
              }
            : {}),
          ...(payload?.confirmationNumber && { confirmationNumber: payload.confirmationNumber }),
          ...((statusChangeModalData.action === "accept" || statusChangeModalData.action === "updateConfirmation") && payload?.startTime && { startTime: payload.startTime }),
          ...((statusChangeModalData.action === "accept" || statusChangeModalData.action === "updateConfirmation") && payload?.teeDate && { teeDate: payload.teeDate }),
        }
      }))
    }}
  />
      
      <CancelBookingModal
        showModal={showCancelBookModal}
        handleClose={handleCloseModal}
        cancelBooking={cancelBooking}
        bookingCancelStatus={bookingCancelStatus}
      ></CancelBookingModal>

      <ProposeTime
        t={t}
        onSubmit={(modalData)=>{
          dispatch(bookingActions.updateNetRateBooking({
          bookingId:selectedTeeTime?._id,
            data:{
              ...modalData
            }
          }))
        }}
        data={selectedTeeTime}
        setClose={()=>setSelectedTeeTime(null)}/>
      </>
  );
};

export default BookingDetail;
